import { useTranslation } from "react-i18next";
import type { HostStripeMovementHistory } from "@workspace/api-client-react";

export function HostStripeHistoryPanel({ history }: { history?: HostStripeMovementHistory }) {
  const { t, i18n } = useTranslation();
  if (!history) return null;
  const kinds = {
    payment: t("owner_booking.history_payment", "Payment"),
    refund: t("owner_booking.history_refund", "Refund"),
    transfer: t("owner_booking.history_transfer", "Transfer to host"),
    transfer_reversal: t("owner_booking.history_reversal", "Transfer reversal"),
  };
  return <section className="journey-panel rounded-2xl border border-border p-5" data-testid="host-stripe-history">
    <h2 className="mb-3 text-base font-semibold">{t("owner_booking.stripe_history", "Recorded Stripe movements")}</h2>
    {!!history.unresolvedRecords && <p role="status" className="mb-3 text-sm text-muted-foreground">
      {t("owner_booking.history_participant_review", "Some Stripe records have unresolved participant links and are not shown.")}
    </p>}
    {history.state !== "recorded" ? <p className="text-sm text-muted-foreground">
      {history.state === "unavailable" ? t("owner_booking.history_unavailable", "Stripe history unavailable")
        : t("owner_booking.history_absent", "No Stripe movement records found")}
    </p> : <ul className="divide-y divide-border">
      {history.movements.map((m, i) => <li key={i} className="flex justify-between gap-4 py-3 text-sm">
        <div><span className="font-medium">{kinds[m.kind]}</span>
          <span className="ml-2 text-muted-foreground">{t(`owner_booking.history_${m.status}`, m.status)}</span>
          {m.recordedAt && <p className="text-xs text-muted-foreground">
            {t("owner_booking.history_recorded_on", "Recorded on")} {new Date(m.recordedAt).toLocaleString(i18n.language)}
          </p>}
        </div>
        <span className="text-right tabular-nums">{m.amount == null
          ? t("owner_booking.history_amount_unavailable", "Amount unavailable")
          : m.currency
            ? new Intl.NumberFormat(i18n.language, { style: "currency", currency: m.currency }).format(m.amount)
            : `${new Intl.NumberFormat(i18n.language).format(m.amount)} (${t("owner_booking.history_currency_unavailable", "currency unavailable")})`}
        </span>
      </li>)}
    </ul>}
  </section>;
}
